<template>
  <Button v-if="!loading" v-bind="$attrs" />
  <Button
    v-else
    v-bind="$attrs"
    icon="pi pi-spin pi-spinner"
    iconPos="right"
    disabled
  />
</template>

<script>
export default {
  name: 'AppButton',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
</style>